import { createApp } from 'vue'
import App from './App.vue'
import mitt from 'mitt'
import UUID from "vue3-uuid";

import './css/tailwind.css'

const eventBus = mitt()
const app = createApp(App)
app.use(UUID)
app.config.globalProperties.eventBus = eventBus
app.mount('#app')
